import {Eventify} from './Eventify.js';
import {PollRobotTemplate} from './PollRobotTemplate.js';
import {VeejayTargetDisplay} from './VeejayTargetDisplay.js';
import {Public} from './Public.js';
export class VeejayAudience {
	computeChannel(el, attr) {
		let channel = el.getAttribute(attr);
		if (!channel || ``==channel) {
			let pathParts = document.location.pathname.split(`/`);
			channel = pathParts[pathParts.length-1];
			if (``==channel && 1<pathParts.length) {
				channel=pathParts[pathParts.length-2];
			}
			if (``==channel) {
				console.log(`VeejayAudience: you MUST set a data-channel, or have a valid ending path element`);
				// alert(`data-channel invalid`);
				return;
			}
		}
		return channel;
	}
	constructor(el) {
		if (!el) {
			return;
		}
		this.parent = el;
		let url = el.getAttribute(`data-url`);
		let channel = this.computeChannel(el, `data-channel`);

		let channelUrl = `${url}${Public.Prefix}veejay/sse/${channel}`;
		console.log(`creating VeejayAudience to listen to ${channelUrl}`);
		this.sse = new EventSource(channelUrl);
		this.sse.addEventListener(`ping`, evt=>{
			console.log(`veejay-sse ping: data = `, evt.data);
			console.log(`veejay-sse ping at ${JSON.parse(evt.data)}`);
		});
		this.sse.addEventListener(`message`, evt=>{
			console.log(`veejay-sse got message, data = `, evt.data);
		});
		this.sse.addEventListener(`show-target`, evt=>{
			this.showTarget(JSON.parse(evt.data));
		});
		this.sse.addEventListener(`close-target`, evt=>{
			console.log(`veejay-sse close-target event received`);
			this.closeTarget(JSON.parse(evt.data));
		});
		this.sse.addEventListener(`show-breakouts`, evt=>{
			console.log(`veejay-sse show-breakouts event received`);			
			this.showBreakouts(JSON.parse(evt.data));
		})
		this.sse.addEventListener(`hide-breakouts`, evt=>{
			console.log(`veejay-sse hide-breakouts event received`);
			this.hideBreakouts(JSON.parse(evt.data));
		})
		this.sse.onmessage = evt=>{
			console.log(`veejay-sse got unnamed message: `, evt);
		};

		[this.el, this.$] = PollRobotTemplate(`VeejayAudience`);
		document.body.appendChild(this.el);

		console.log(`VeejayAudience constructed, listening to ${channel}`);

		this.el.addEventListener(`pollrobot-answer-submit`, evt=>{
			this.answerSubmit(evt.detail);
		});
	}
	showBreakouts(js) {
		console.log(`showBreakouts, js = `, js);
		let list = document.getElementById(`breakout-rooms-list`);
		if (!list) {
			let participants = document.querySelector(".toolbox-button[aria-label='Participants'][role='button']");
			if (!participants) {
				console.warn(`Failed to find Participants button`);
				return;
			}
			participants.click();
			list = document.getElementById(`breakout-rooms-list`);
			if (!list) {
				console.warn(`Failed to find breakout-rooms-list`);
				return;
			}
		}
		let container = list.querySelectorAll(`div.breakout-room-container`);
		if (0==container.length) {
			console.warn(`No breakout rooms to show`);
			return;
		}
		if (this.breakoutsDiv) {
			this.breakouts$.breakouts.innerHTML = ``;			
		} else {
			[this.breakoutsDiv, this.breakouts$] = PollRobotTemplate(`VeejayBreakouts`);
			this.breakouts$.veejay_breakouts_close.addEventListener(`click`, evt=>{
				this.hideBreakouts(null);
			});
		}
		container.forEach(c=>{
			console.log(`container = `, c);
			// let title = c.querySelector(`div:nth-child(2)>div>span`);
			// go to >div:nth-child(2)
			let child2 = c.firstElementChild.nextElementSibling;
			console.log(`child2 = `, child2);
			// Go to &>div>span
			let title = child2.firstElementChild.firstElementChild.innerText;
			// Go to &>div:nth-child(2)>button
			let btn = child2.firstElementChild.nextElementSibling.firstElementChild;
			console.log(`Got breakout room: '${title}', `, btn);

			let br = document.createElement(`div`);
			br.classList.add(`breakout`);
			br.addEventListener(`click`, evt=>{
				this.hideBreakouts(null);
				btn.click();
			});
			br.innerText = title;
			this.breakouts$.breakouts.appendChild(br);
		});
		if (!document.getElementById(`veejay-breakouts-container`)) {
			console.log(`adding veejay-breakouts-container `, this.breakoutsDiv);
			document.body.appendChild(this.breakoutsDiv);
		}
	}
	hideBreakouts(js) {
		console.log(`hideBreakouts, js = `, js);
		if (this.breakoutsDiv)
			this.breakoutsDiv.remove();
	}
	showResult(js) {
		console.log(`VeejayAudience.showResult js=`, js);
		if (this.resultViewer && this.resultViewer.matchesJs(js)) {
			this.resultViewer.setJs(js);
		} else {
			this.clearThen( ()=> {
				this.el.innerHTML = ``;
				this.resultViewer = new AskResultViewer(this.el);
				this.resultViewer.setJs(js);
				setTimeout(()=>{
					this.el.classList.add(`showing`);
				}, 100);				
			});
		}
	}
	closeResult(js) {
		console.log(`Audience.closeResult js=`, js);
		this.resultViewer = false;
		this.clearThen();
		// if (this.resultViewer && this.resultViewer.matchesJs(js)) {
		// 	clearThen(false);
		// }
	}
	// clearThen removes whatever is showing, then executes the given callback
	clearThen(f) {
		let done = ()=>{
			this.el.removeEventListener(`transitionend`, done);
			this.el.innerHTML = ``;
			if (f) {
				f();
			}
		}
		if (this.el.classList.contains(`showing`)) {
			this.el.addEventListener(`transitionend`, done);
			this.el.classList.remove(`showing`);
		} else {
			done();
		}
	}
	answerSubmit(js) {
		console.log(`body = `, JSON.stringify(js));
		fetch(`${this.parent.getAttribute(`data-url`)}/poll/answer/js`, {
			method: "POST",
			body: JSON.stringify(js)
		})
		.then( res=>res.json() )
		.then( js=>{
			console.log(`received on answer submission: `, js);
			return Promise.resolve(true);
		})
		.catch(err =>{
			this.doError(err);
		});
		this.closePoll(js);
	}
	closeTarget(js) {
		console.log(`close-target `, js);
		this.$.content.innerHTML = ``;
		this.el.classList.remove(`showing`);
	}
	doError(err) {
		console.log(err);
		alert(err);
	}
	showPromise(setShowing) {
		/** @TODO catch the off-change that we get here between the beginning of a
		    transition and the end */
		if ((setShowing && this.el.classList.contains(`showing`)) ||
		    (!setShowing && !this.el.classList.contains(`showing`))) {
			return Promise.resolve(true);
		}
		// let te = ()=>{};
		// let resolve = false;
		// let reject = false;
		// let promise = new Promise((resolve, reject) => {
		// 	this.resolve = resolve;
		// 	this.reject = reject;
		// });
		// this.el.addEventListener(`transitionend`, te);
		// te = ()=>{
		// 	this.el.removeEventListener(`transitionend`, te);
		// 	this.show_in_transition = false;
		// }
		if (setShowing) {
			this.el.classList.add(`showing`);
		} else {
			this.el.classList.remove(`showing`);
		}
		return Promise.resolve(true);
		// this.show_in_transition = true;
	}
	showTarget(js) {
		console.log(`VeedoAudience::showTarget: `, js);
		let url = js.Data.url;
		switch (js.Data.action) {
			case `html`:
				this.$.content.innerHTML = ``;
				new VeejayTargetDisplay(this.$.content, js);
				setTimeout(()=>{
					this.el.classList.add(`showing`);
				}, 100);
				break;
			case `location`:
				document.location = url;
				break;
			default:
				console.error(`Unrecognized action:`, js.Data.action);
		}
	}

	static init() {
		new VeejayAudience(document.querySelector(`[data-instance="VeejayAudience"]`));
	}
}
